<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 头部 -->
		<div class="titleView">
			<el-row style="padding-left:10px;">
				<el-col :span="4" v-if="detailData.procureNo">采购批次号: <span >{{ detailData.procureNo }}</span> </el-col>
				<el-col :span="4" v-if="!detailData.procureNo">采购批次号: <span v-for="(item,index) in detailData.procureRequestNo" :key="index">{{ item }}</span> </el-col>
				<el-col :span="4" v-if="detailData.createOperationInfo">采购人: {{detailData.createOperationInfo.userName}}</el-col>
				<el-col :span="4">
					<span v-if="detailData.state == 1">采购状态:采购中</span>
					<span v-if="detailData.state == 3">采购状态:采购完成</span>
					<span v-if="detailData.state == 4">采购状态:采购取消</span>
				</el-col>
				<el-col :span="4" v-if="detailData.createOperationInfo">申请日期: {{detailData.createOperationInfo.operationTime}}</el-col>
				<el-col :span="8" style="text-align: right;">
					<el-button @click="handleUploadClick(2)" v-if="cgtabs == 2" size="small">下载报货单</el-button>
					<el-button @click="handleUploadClick(1)" v-if="cgtabs == 2" size="small">下载验货单</el-button>
					<!-- <el-button @click="handleRecordClick">门店出库记录</el-button> -->
					<el-button @click="handleUploadRecordClick" size="small">下载分拨单</el-button>
					<el-button type="warning" @click="handleBackClick" style="margin-right: 40px;" size="small">返回</el-button>
				</el-col>
			</el-row>
			<el-row style="padding-left:10px;">
				<el-col :span="3">产品数量: {{detailData.procureGoodsList.length}}</el-col>
				<el-col :span="3">采购数量: {{detailData.count}}</el-col>
				<el-col :span="3" >成本总价: {{detailData.sumPrice}}</el-col>
			</el-row>
		</div>
		<!-- tab切换 -->
		<div class="tabs">
			<el-button @click="handleTabClick(-1)" :type="tabIndex == -1?'warning':''" size="small">全部</el-button>
			<el-button v-for="(item,index) in storeTab" :key="index" @click="handleTabClick(index)" :type="tabIndex == index?'warning':''" size="small">{{item}}</el-button>
		</div>
		<!-- 滚动位置 -->
		<div class="scrollView" style="overflow-y: scroll;" ref="scrollView">
			<!-- 全部商品 -->
			<div id="page-1">
				<!-- 商品类 -->
				<div class="shopClass" v-if="shops.length > 0">
					<div class="comH2" @click="showShop = !showShop">
						<div>商品类</div>
						<i class="el-icon-caret-bottom" v-if="showShop"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="showShop">
						<el-table ref="allShopTable" :data="shops" tooltip-effect="dark" @selection-change="handleAllShopChange" size="small">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="title" label="商品名称" />
							<el-table-column :key="2" width="50">
								<template slot-scope="scope">
									<el-tag effect="dark" v-if="scope.row.addType == 2" size="small" type="success">采</el-tag>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="brand" label="品牌" align="center" />
							<el-table-column :key="4" label="供应商" prop="suppliers">
								<template slot-scope="scope">
									<el-select v-model="scope.row.supplierId" placeholder="请选择" @change="selectDChange(scope.row)"  filterable size="small">
										<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
									</el-select>
								</template>
							</el-table-column>
							<el-table-column :key="5" prop="skuValue" label="规格" align="center" width="120" />
							<el-table-column :key="6" prop="unit" label="单位" align="center" />
							<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="7" prop="goodsCount" label="采购数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.goodsCount == 0?'--':scope.row.goodsCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="8" prop="count" label="实收数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.paidCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="9" prop="count" label="赠品数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.givingCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="procure_goods_remark" label="备注" align="center">
								<template slot-scope="scope">
									<div v-if="scope.row.validationData == null">--</div>
									<div v-else>
										<span v-if="scope.row.validationData.remarks == ''">--</span>
										<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column :key="13" label="状态" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.procureGoodsState == -2">无货</span>
									<span v-if="scope.row.procureGoodsState == 1">申请中</span>
									<span v-if="scope.row.procureGoodsState == 2">部分验货</span>
									<span v-if="scope.row.procureGoodsState == 3">未分拨</span>
									<span v-if="scope.row.procureGoodsState == 4">已分拨</span>
									<span v-if="scope.row.procureGoodsState == 5">分拨出库</span>
									<span v-if="scope.row.procureGoodsState == 6">门店部分收货</span>
									<span v-if="scope.row.procureGoodsState == 7">门店收货</span>
								</template>
							</el-table-column>
							<el-table-column :key="15" label="异常" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validationData.abnormalCount == 0">--</span>
									<el-popover v-else placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.validationData.abnormalInfo.leakageCount+' 破损:'+scope.row.validationData.abnormalInfo.brokenCount+' 过期:'+scope.row.validationData.abnormalInfo.overdueCount+' 调换:'+scope.row.validationData.abnormalInfo.switchCount+' 无货:'+scope.row.validationData.abnormalInfo.noCount">
										<div slot="reference">异常{{scope.row.validationData.abnormalCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column :key="14" label="操作" align="center" width="140">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleDeleteClick(scope.row)" v-if="scope.row.add_type == 2 && scope.row.procureGoodsState==1">删除</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState==1" @click="handleInspectionClick(scope.row)">验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3 || scope.row.procureGoodsState == 2" @click="handleResetGoodsClick(scope.row)">重新验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3" @click="handleAssignClick(scope.row)">分拨</el-button>
								</template>
							</el-table-column>
						</el-table>
						<div class="allNum">
							<div>共{{shopCount}}件</div>
						</div>
					</div>
				</div>
				<!-- 医疗类 -->
				<div class="shopClass" v-if="drugs.length > 0">
					<div class="comH2" @click="showDrug = !showDrug">
						<div>医疗类</div>
						<i class="el-icon-caret-bottom" v-if="showDrug"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="showDrug">
						<el-table ref="allDrugTable" :data="drugs" tooltip-effect="dark" @selection-change="handleAllDrugChange" size="small">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="title" label="商品名称" />
							<el-table-column :key="2" width="50">
								<template slot-scope="scope">
									<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="brand" label="品牌" align="center" />
							<el-table-column :key="4" label="供应商" prop="suppliers">
								<!-- <template slot-scope="scope">
									<span>{{scope.row.supplier_name}}</span>
								</template> -->
								<template slot-scope="scope">
									<el-select v-model="scope.row.supplierId" placeholder="请选择" @change="selectDChange(scope.row)"  filterable size="small">
										<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
									</el-select>
								</template>
							</el-table-column>
							
							<el-table-column :key="5" prop="skuValue" label="规格" align="center" width="120" />
							<el-table-column :key="6" prop="unit" label="单位" align="center" />
							<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="7" prop="goodsCount" label="采购数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.goodsCount == 0?'--':scope.row.goodsCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="8" label="实收数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.paidCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="9" label="赠品数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.givingCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="procure_goods_remark" label="备注" align="center">
								<template slot-scope="scope">
									<div v-if="scope.row.validationData == null">--</div>
									<div v-else>
										<span v-if="scope.row.validationData.remarks == ''">--</span>
										<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column :key="13" label="状态" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.procureGoodsState == -3">异常</span>
									<span v-if="scope.row.procureGoodsState == -2">无货</span>
									<span v-if="scope.row.procureGoodsState == 1">未验货</span>
									<span v-if="scope.row.procureGoodsState == 2">部分验货</span>
									<span v-if="scope.row.procureGoodsState == 3">未分拨</span>
									<span v-if="scope.row.procureGoodsState == 4">部分分拨</span>
									<span v-if="scope.row.procureGoodsState == 5">未打码</span>
									<span v-if="scope.row.procureGoodsState == 6">部分打码</span>
									<span v-if="scope.row.procureGoodsState == 7">全部打码</span>
									<span v-if="scope.row.procureGoodsState == 8">分拨出库</span>
									<span v-if="scope.row.procureGoodsState == 9">门店部分收货</span>
									<span v-if="scope.row.procureGoodsState == 10">门店全部收货</span>
								</template>
							</el-table-column>
							<el-table-column :key="15" label="异常" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validationData.abnormalCount == 0">--</span>
									<el-popover v-else placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.validationData.abnormalInfo.leakageCount+' 破损:'+scope.row.validationData.abnormalInfo.brokenCount+' 过期:'+scope.row.validationData.abnormalInfo.overdueCount+' 调换:'+scope.row.validationData.abnormalInfo.switchCount+' 无货:'+scope.row.validationData.abnormalInfo.noCount">
										<div slot="reference">异常{{scope.row.validationData.abnormalCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column :key="14" label="操作" align="center" width="140">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleDeleteClick(scope.row)" v-if="scope.row.add_type == 2 && scope.row.procureGoodsState==1">删除</el-button>
									
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState==1" @click="handleInspectionClick(scope.row)">验货</el-button>
									
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3 || scope.row.procureGoodsState == 2" @click="handleResetGoodsClick(scope.row)">重新验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3" @click="handleAssignClick(scope.row)">分拨</el-button>
								</template>
							</el-table-column>

						</el-table>
						<div class="allNum">
							<div>共{{drugCount}}件</div>
						</div>
					</div>
				</div>
				<!-- 耗材类 -->
				<div class="shopClass" v-if="haocais.length > 0">
					<div class="comH2" @click="showHaocai = !showHaocai">
						<div>耗材类</div>
						<i class="el-icon-caret-bottom" v-if="showHaocai"></i>
						<i class="el-icon-caret-top" v-else></i>
					</div>
					<div class="tableWarp" v-if="showHaocai">
						<el-table ref="allHaocaiTable" :data="haocais" tooltip-effect="dark" @selection-change="handleAllHaocaiChange" size="small">
							<el-table-column type="selection" width="55"/>
							<el-table-column :key="1" prop="title" label="商品名称" />
							<el-table-column :key="2" width="50">
								<template slot-scope="scope">
									<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
								</template>
							</el-table-column>
							<el-table-column :key="3" prop="brand" label="品牌" align="center">
								<template>
									<span>--</span>
								</template>
							</el-table-column>
							<el-table-column :key="4" label="供应商" prop="suppliers">
								<template slot-scope="scope">
									<el-select v-model="scope.row.supplierId" placeholder="请选择" @change="selectDChange(scope.row)" filterable size="small">
										<el-option v-for="item in suppliers" :key="item._id" :label="item.basic_info.name" :value="item._id" />
									</el-select>
								</template>
							</el-table-column>
							<el-table-column :key="5" prop="skuValue" label="规格" align="center" width="120">
								<template>
									<span>--</span>
								</template>
							</el-table-column>
							<el-table-column :key="6" prop="unit" label="单位" align="center" />
							<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="7" prop="goodsCount" label="采购数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.goodsCount == 0?'--':scope.row.goodsCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="8" label="实收数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.paidCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="9" label="赠品数量" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData == null?'0':scope.row.validationData.givingCount}}</span>
								</template>
							</el-table-column>
							<el-table-column :key="11" prop="procure_goods_remark" label="备注" align="center">
								<template slot-scope="scope">
									<div v-if="scope.row.validationData == null">--</div>
									<div v-else>
										<span v-if="scope.row.validationData.remarks == ''">--</span>
										<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column :key="13" label="状态" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.procureGoodsState == -3">异常</span>
									<span v-if="scope.row.procureGoodsState == -2">无货</span>
									<span v-if="scope.row.procureGoodsState == 1">未验货</span>
									<span v-if="scope.row.procureGoodsState == 2">部分验货</span>
									<span v-if="scope.row.procureGoodsState == 3">未分拨</span>
									<span v-if="scope.row.procureGoodsState == 4">部分分拨</span>
									<span v-if="scope.row.procureGoodsState == 5">未打码</span>
									<span v-if="scope.row.procureGoodsState == 6">部分打码</span>
									<span v-if="scope.row.procureGoodsState == 7">全部打码</span>
									<span v-if="scope.row.procureGoodsState == 8">分拨出库</span>
									<span v-if="scope.row.procureGoodsState == 9">门店部分收货</span>
									<span v-if="scope.row.procureGoodsState == 10">门店全部收货</span>
								</template>
							</el-table-column>
							<el-table-column :key="15" label="异常" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.validationData.abnormalCount == 0">--</span>
									<el-popover v-else placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.validationData.abnormalInfo.leakageCount+' 破损:'+scope.row.validationData.abnormalInfo.brokenCount+' 过期:'+scope.row.validationData.abnormalInfo.overdueCount+' 调换:'+scope.row.validationData.abnormalInfo.switchCount+' 无货:'+scope.row.validationData.abnormalInfo.noCount">
										<div slot="reference">异常{{scope.row.validationData.abnormalCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column :key="14" label="操作" align="center" width="140">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="handleDeleteClick(scope.row)" v-if="scope.row.add_type == 2 && scope.row.procureGoodsState==1">删除</el-button>
									
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState==1" @click="handleInspectionClick(scope.row)">验货</el-button>
									
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3 || scope.row.procureGoodsState == 2" @click="handleResetGoodsClick(scope.row)">重新验货</el-button>
									<el-button type="text" size="small" v-if="scope.row.procureGoodsState == 3" @click="handleAssignClick(scope.row)">分拨</el-button>
								</template>
							</el-table-column>
						</el-table>
						<div class="allNum">
							<div>共{{drugCount}}件</div>
							<div>成本价合计：{{haocaiPrice.toFixed(2)}}</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 其他门店商品 -->
			<template v-for="(item,index) in stores">
				<div :id="'page'+index" :key="index">
					<div class="storeName">
						<div @click="handleStoreClick(index)">
							<span>采购门店:{{item.shopInfo.shopName}}</span>
							<i class="el-icon-caret-bottom" v-if="item.isShow" style="color: #1890FF;"></i>
							<i class="el-icon-caret-top" v-else style="color: #1890FF;"></i>
						</div>
					</div>
					<!-- 商品类 -->
					<div class="shopClass" v-if="item.distributionGoodsList.shop.shops.length > 0 && item.isShow" >
						<div class="comH2" @click="handleStoreZLClick(index,1)">
							<div>商品类</div>
							<i class="el-icon-caret-bottom" v-if="item.distributionGoodsList.shop.isShow"></i>
							<i class="el-icon-caret-top" v-else></i>
						</div>
						<div class="tableWarp" v-if="item.distributionGoodsList.shop.isShow">
							<el-table :ref="'shopTable'+index" :data="item.distributionGoodsList.shop.shops" tooltip-effect="dark" @selection-change="handleSelectShop(arguments[0],index)" size="small">
								<el-table-column type="selection" width="55"/>
								<el-table-column :key="1" prop="title" label="商品名称" />
								<el-table-column :key="2" width="50">
									<template slot-scope="scope">
										<el-tag effect="dark" v-if="scope.row.addType == 2" size="small" type="success">采</el-tag>
									</template>
								</el-table-column>
								<el-table-column :key="3" prop="brand" label="品牌" align="center" />
								<el-table-column :key="4" prop="skuValue" label="规格" align="center" width="120" />
								<el-table-column :key="10" prop="count" label="条码" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.barCode?scope.row.barCode:'--'}}</span>
								</template>
							</el-table-column>
								<el-table-column :key="5" prop="unit" label="单位" align="center" />
								<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
								<el-table-column :key="6" prop="requestCount" label="采购数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.requestCount == 0?'--':scope.row.requestCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="7" prop="distributionCount" label="分拨数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.distributionCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="8" prop="procure_goods_remark" label="备注" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.validationData == null">--</div>
										<div v-else>
											<span v-if="scope.row.validationData.remarks == ''">--</span>
											<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="9" prop="procure_goods_remark" label="门店验收状态" align="center">
									<template slot-scope="scope">
											<span v-if="scope.row.distributionState == 0">未出库</span>
											<span v-if="scope.row.distributionState == 1">未验收</span>
											<span v-if="scope.row.distributionState == 2" style="color: red;font-weight: bold;">已验收</span>
								</template>
								</el-table-column>
								<el-table-column :key="15" label="异常" align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.acceptanceInfo == null">--</div>
											<template v-if="scope.row.acceptanceInfo != null">
												<div v-if="scope.row.acceptanceInfo.abnormalInfo == null">--</div>
												<template v-if="scope.row.acceptanceInfo.abnormalInfo != null">
													<el-popover placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.acceptanceInfo.abnormalInfo.leakageCount+' 破损:'+scope.row.acceptanceInfo.abnormalInfo.brokenCount+' 过期:'+scope.row.acceptanceInfo.abnormalInfo.overdueCount+' 调换:'+scope.row.acceptanceInfo.abnormalInfo.switchCount+' 无货:'+scope.row.acceptanceInfo.abnormalInfo.noCount">
														<div slot="reference">异常{{scope.row.acceptanceInfo.abnormalInfo.leakageCount+scope.row.acceptanceInfo.abnormalInfo.brokenCount+scope.row.acceptanceInfo.abnormalInfo.overdueCount+scope.row.acceptanceInfo.abnormalInfo.switchCount+scope.row.acceptanceInfo.abnormalInfo.noCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
													</el-popover>
												</template>
											</template>
										</div>
									</template>
								</el-table-column>
							</el-table>
							<div class="allNum">
								<div>申请采购共{{item.distributionGoodsList.shop.allCount}}件</div>
								<!-- <div>成本价合计：{{item.procureGoodsList.shop.allPrice.toFixed(2)}}</div> -->
								<!-- <div>分拨共{{item.procureGoodsList.drug.paidcount}}件</div> -->
							</div>
						</div>
					</div>
					<!-- 医疗类 -->
					<div class="shopClass" v-if="item.distributionGoodsList.drug.drugs.length > 0 && item.isShow">
						<div class="comH2" @click="handleStoreZLClick(index,2)">
							<div>医疗类</div>
							<i class="el-icon-caret-bottom" v-if="item.distributionGoodsList.drug.isShow"></i>
							<i class="el-icon-caret-top" v-else></i>
						</div>
						<div class="tableWarp" v-if="item.distributionGoodsList.drug.isShow">
							<el-table :ref="'drugTable'+index" :data="item.distributionGoodsList.drug.drugs" tooltip-effect="dark" @selection-change="handleSelectDrug(arguments[0],index)" size="small">
								<el-table-column type="selection" width="55"/>
								<el-table-column :key="1" prop="title" label="商品名称" />
								<el-table-column :key="2" width="50">
									<template slot-scope="scope">
										<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
									</template>
								</el-table-column>
								<el-table-column :key="3" prop="brand" label="品牌" align="center" />
								<el-table-column :key="4" prop="skuValue" label="规格" align="center" width="120" />
								<el-table-column :key="5" prop="unit" label="单位" align="center" />
								<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
								<el-table-column :key="6" prop="requestCount" label="采购数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.requestCount == 0?'--':scope.row.requestCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="7" prop="count" label="分拨数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.distributionCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="8" prop="procure_goods_remark" label="备注" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.validationData == null">--</div>
										<div v-else>
											<span v-if="scope.row.validationData.remarks == ''">--</span>
											<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="9" prop="procure_goods_remark" label="门店验收状态" align="center">
									<template slot-scope="scope">
										<template>
											<span v-if="scope.row.distributionState == 0">未出库</span>
											<span v-if="scope.row.distributionState == 1">未验收</span>
											<span v-if="scope.row.distributionState == 2" style="color: red;font-weight: bold;">已验收</span>
										</template>
									</template>
								</el-table-column>
								<el-table-column :key="15" label="异常" align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.acceptanceInfo == null">--</div>
											<template v-if="scope.row.acceptanceInfo != null">
												<div v-if="scope.row.acceptanceInfo.abnormalInfo == null">--</div>
												<template v-if="scope.row.acceptanceInfo.abnormalInfo != null">
													<el-popover placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.acceptanceInfo.abnormalInfo.leakageCount+' 破损:'+scope.row.acceptanceInfo.abnormalInfo.brokenCount+' 过期:'+scope.row.acceptanceInfo.abnormalInfo.overdueCount+' 调换:'+scope.row.acceptanceInfo.abnormalInfo.switchCount+' 无货:'+scope.row.acceptanceInfo.abnormalInfo.noCount">
														<div slot="reference">异常{{scope.row.acceptanceInfo.abnormalInfo.leakageCount+scope.row.acceptanceInfo.abnormalInfo.brokenCount+scope.row.acceptanceInfo.abnormalInfo.overdueCount+scope.row.acceptanceInfo.abnormalInfo.switchCount+scope.row.acceptanceInfo.abnormalInfo.noCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
													</el-popover>
												</template>
											</template>
										</div>
									</template>
								</el-table-column>
					
							</el-table>
							<div class="allNum">
								<div>申请采购共{{item.distributionGoodsList.drug.allCount}}件</div>
								<!-- <div>成本价合计：{{item.procureGoodsList.shop.allPrice.toFixed(2)}}</div> -->
								<!-- <div>分拨共{{item.procureGoodsList.drug.paidcount}}件</div> -->
							</div>
						</div>
					</div>
					<!-- 耗材类 -->
					<div class="shopClass" v-if="item.distributionGoodsList.haocai.haocais.length > 0 && item.isShow">
						<div class="comH2" @click="handleStoreZLClick(index,3)">
							<div>耗材类</div>
							<i class="el-icon-caret-bottom" v-if="item.distributionGoodsList.haocai.isShow"></i>
							<i class="el-icon-caret-top" v-else></i>
						</div>
						<div class="tableWarp" v-if="item.distributionGoodsList.haocai.isShow">
							<el-table :ref="'haocaiTable'+index" :data="item.distributionGoodsList.haocai.haocais" tooltip-effect="dark" @selection-change="handleSelectHaocai(arguments[0],index)" size="small">
								<el-table-column type="selection" width="55"/>
								<el-table-column :key="1" prop="title" label="商品名称" />
								<el-table-column :key="2" width="50">
									<template slot-scope="scope">
										<el-tag effect="dark" v-if="scope.row.add_type == 2" size="small" type="success">采</el-tag>
									</template>
								</el-table-column>
								<el-table-column :key="3" prop="brand" label="品牌" align="center">
									<template>
										<span>--</span>
									</template>
								</el-table-column>
								<el-table-column :key="4" prop="skuValue" label="规格" align="center" width="120">
									<template>
										<span>--</span>
									</template>
								</el-table-column>
								<el-table-column :key="5" prop="unit" label="单位" align="center" />
								<el-table-column :key="13"  label="成本价" align="center">
								<template slot-scope="scope">
									<span>{{scope.row.validationData?scope.row.validationData.costPrice:'--'}}</span>
								</template>
							</el-table-column>
								<el-table-column :key="6" prop="requestCount" label="采购数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.requestCount == 0?'--':scope.row.requestCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="7" prop="count" label="分拨数量" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.distributionCount}}</span>
									</template>
								</el-table-column>
								<el-table-column :key="8" prop="procure_goods_remark" label="备注" align="center">
									<template slot-scope="scope">
										<div v-if="scope.row.validationData == null">--</div>
										<div v-else>
											<span v-if="scope.row.validationData.remarks == ''">--</span>
											<span v-if="scope.row.validationData.remarks != ''">{{scope.row.validationData.remarks}}</span>
										</div>
									</template>
								</el-table-column>
								<el-table-column :key="9" prop="procure_goods_remark" label="门店验收状态" align="center">
									<template slot-scope="scope">
										<template>
											<span v-if="scope.row.distributionState == 0">未出库</span>
											<span v-if="scope.row.distributionState == 1">未验收</span>
											<span v-if="scope.row.distributionState == 2" style="color: red;font-weight: bold;">已验收</span>
										</template>
									</template>
								</el-table-column>
								<el-table-column :key="15" label="异常" align="center">
									<template slot-scope="scope">
										<div>
											<div v-if="scope.row.acceptanceInfo == null">--</div>
											<template v-if="scope.row.acceptanceInfo != null">
												<div v-if="scope.row.acceptanceInfo.abnormalInfo == null">--</div>
												<template v-if="scope.row.acceptanceInfo.abnormalInfo != null">
													<el-popover placement="top-start" title="异常" width="200" trigger="click" :content="' 漏发:'+scope.row.acceptanceInfo.abnormalInfo.leakageCount+' 破损:'+scope.row.acceptanceInfo.abnormalInfo.brokenCount+' 过期:'+scope.row.acceptanceInfo.abnormalInfo.overdueCount+' 调换:'+scope.row.acceptanceInfo.abnormalInfo.switchCount+' 无货:'+scope.row.acceptanceInfo.abnormalInfo.noCount">
														<div slot="reference">异常{{scope.row.acceptanceInfo.abnormalInfo.leakageCount+scope.row.acceptanceInfo.abnormalInfo.brokenCount+scope.row.acceptanceInfo.abnormalInfo.overdueCount+scope.row.acceptanceInfo.abnormalInfo.switchCount+scope.row.acceptanceInfo.abnormalInfo.noCount}}<span class="el-icon-view" style="color: #0000FF;"></span></div>
													</el-popover>
												</template>
											</template>
										</div>
									</template>
								</el-table-column>
							
							</el-table>
							<div class="allNum">
								<div>申请采购共{{item.distributionGoodsList.haocai.allCount}}件</div>
								<!-- <div>成本价合计：{{item.procureGoodsList.shop.allPrice.toFixed(2)}}</div> -->
								<!-- <div>分拨共{{item.procureGoodsList.drug.paidcount}}件</div> -->
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>
		<!-- 底部按钮 -->
		<div class="fix_btn">
			<div class="fix_btn_l">
				<div>备注: {{detailData.remarks == ''?'--':detailData.remarks}}</div>
			</div>
		</div>
		<!-- 分拨出库记录 -->
		<div v-if="dialogRecord_state">
			<dialogRecord @closeOn="handleRecordClose" :recordState.sync="dialogRecord_state" :id.sync="id" :recordData.sync="recordData"></dialogRecord>
		</div>
		<!-- 下载报货单或者验货单 -->
		<div v-if="dialogUpload_state">
			<dialogUpload @closeOn="handleUploadClose" :uploadState.sync="dialogUpload_state" :id.sync="id" :uploadData.sync="uploadData" :uploadType.sync="uploadType" :uploadTitle="uploadTitle"></dialogUpload>
		</div>
	</div>
</template>
<script>

	import {caigouDetail,moreSupplier,supplierList} from "@/api/purchaseApiNew.js"
	import caigouFilter from '@/util/caigouFilter.js'
	import dialogRecord from "../../../components/dialog_record.vue"
	import dialogUpload from "../../../components/dialog_uploadNew.vue"
	import axios from 'axios';
	export default {
		components: {
			dialogRecord,
			dialogUpload,
		},
		data() {
			return {
				shopList: [],
				dialogFormVisible: false,
				textValue: '',
				fixedHeight: '',
				id: this.$route.query.id, //跳转订单id
				cgtabs: this.$route.query.cgtabs,  //切换
				detailData: {}, //订单详情
				shops: [], //商品类
				drugs: [], //药品类
				haocais: [],  //耗材类
				showShop: true, //显示商品类
				showDrug: true, //显示药品类
				showHaocai: true, //显示耗材类
				showUpadate: true, //显示修改记录
				shopCount: 0,
				shopPrice: 0,
				drugCount: 0,
				drugPrice: 0,
				haocaiCount: 0,
				haocaiPrice: 0,
				dialogRecord_state:false,  //分拨出库状态
				dialogUpload_state:false,  //下载单弹框
				tabIndex: -1, //tab默认
				storeTab: [], //门店tab切换
				stores:[],  //各个门店列表
				recordData:null,  //分拨出库数据
				uploadData:null,  //下载单数据
				uploadType:0,  //下载按钮状态
				uploadTitle:'',  //按钮头部
				allSelectShop:[],  //全部选中商品
				allSelectDrug:[],  //全部选中药品
				allSelectHaocai:[],  //全部选中耗材
				endStoreArr:[],  //分拨所选中商品整合
				remarkTextValue:'',  //整体备注
				allCode:[], //全部选中条码
				suppliers:[],  //供应商列表
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getDetailData();
			this.getSuppliersData(); 
		},
		methods: {
//单个修改供应商
			selectDChange(row){
				console.log(row)
				let idArr = [];
				let selectName = this.suppliers.find(val=>val._id==row.supplierId).basic_info.name;
				console.log(selectName)
				idArr.push(row.id)
				let parmars = {
					procureGoodsIds:idArr,
					supplierId:row.supplierId,
					supplierName:selectName
				}
				moreSupplier(parmars).then((res)=>{
					
					if(res.code == 0){
						this.$message({
							message: '修改成功',
							type: 'success'
						});
					}
				})
			},
			//获取采购列表
			getSuppliersData(){
				supplierList().then((res)=>{
					if(res.code == 0){
						// console.log('供应商列表',res.data);
						this.suppliers = res.data.data;
					}
				})
			},
	//下载分拨单
	handleUploadRecordClick(){
				console.log(this.detailData);
				axios.get(process.env.VUE_APP_zichan+'/api/Procurement/UpLoadDistribution',{
					params:{
						procureNo:this.detailData.procureNo,
					},
					responseType: 'blob'
				}).then(response => {
					// console.log(response)
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '分拨单导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
				}).catch(err => {
						console.log(err)
				})
			},
			//返回按钮
			handleBackClick(){
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.back();
					let storage = window.sessionStorage
					storage.setItem("cgtabs",this.cgtabs)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
		
			//全部商品选中
			handleAllShopChange(val){
				this.allSelectShop = val;
			},
			//全部药品
			handleAllDrugChange(val){
				this.allSelectDrug = val
			},
			//全部耗材
			handleAllHaocaiChange(val){
				this.allSelectHaocai = val
			},
			//table子项商品
			handleSelectShop(val,index){
				console.log(val,index)
				this.endStoreArr[index].distributionGoodsList.shop.shops = val 
				console.log(this.endStoreArr[index])
			}, 
			//table子项医疗
			handleSelectDrug(val,index){
				console.log(val,index)
				this.endStoreArr[index].distributionGoodsList.drug.drugs = val 
			}, 
			//table子项耗材
			handleSelectHaocai(val,index){
				console.log(val,index)
				this.endStoreArr[index].distributionGoodsList.haocai.haocais = val 
			}, 
			//重构日期
			FormatDate(item){
				let time = new Date(item*1000) 
				let year = time.getFullYear()
				let month = time.getMonth() + 1<10?'0'+(time.getMonth() + 1):time.getMonth() + 1
				let date = time.getDate()<10?'0'+time.getDate():time.getDate()
				return year+'-'+month+'-'+date
			},
			//关闭分拨出库弹框
			handleRecordClose(val){
				this.dialogRecord_state = val
			},
			//下载验货单和下载报货单按钮
			handleUploadClick(type){
				if(this.detailData.supplier_list.length == 0){
					this.$message({
						message:'请选择供应商',
						type:'warning'
					})
					return
				}
				if(type == 1){
					this.uploadType = type;
					this.uploadTitle = '下载验货单';
				}else if(type == 2){
					this.uploadType = type
					this.uploadTitle = '下载报货单';
				}
				this.dialogUpload_state = true
				this.uploadData = this.detailData
			},
			//关闭下载
			handleUploadClose(val){
				this.dialogUpload_state = val
			},
			//分拨出库按钮
			handleRecordClick(){
				if(this.detailData.procure_distributions.length == 0){
					this.$message({
						message:'暂无分拨出库记录',
						type:"warning"
					})
					return;
				}
				this.dialogRecord_state = true
				this.recordData = this.detailData
			},
			//分拨前-门店数据
			getStoreStartData() {
				
				let stores = [...this.detailData.shopDistributionResponseList];
				// console.log('门店信息',stores)
				let arr = [];
				let shops = [];
				let drugs = [];
				let haocais = [];
				if (stores.length != 0) {
					for (let i = 0; i < stores.length; i++) {
						// 获取tab切换
						if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr12') {
							arr.push('金水区店')
						} else  if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr18') {
							arr.push('郑东新区店')
						} else if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr17') {
							arr.push('线上旗舰店')
						} else if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr14') {
							arr.push('指挥中心店')
						} else if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr10') {
							arr.push('驯养中心')
						} else if (stores[i].shopInfo.shopId == '5e9412e0b2bfbc089daerr11') {
							arr.push('小程序')
						}
						shops = [];
						drugs = [];
						haocais = [];
						// console.log(stores[0].procureGoodsList.length)
						//重组商品列表
						for(let j = 0; j<stores[i].distributionGoodsList.length;j++){
							if(stores[i].distributionGoodsList[j].goodsType == '0'){
								shops[j] = stores[i].distributionGoodsList[j]
							}else if(stores[i].distributionGoodsList[j].goodsType == '1'){
								drugs[j] =  stores[i].distributionGoodsList[j]
							}else if(stores[i].distributionGoodsList[j].goodsType == '7'){
								haocais[j] =  stores[i].distributionGoodsList[j]
							}
							shops = shops.filter(item => item);
							drugs = drugs.filter(item => item);
							haocais = haocais.filter(item => item);
						}
						// console.log(shops,drugs)
						stores[i].distributionGoodsList = {
							shop:{
								shops:shops,
								isShow:true,
								allCount:this.getStoreAllData(shops).count,
								// paidcount:this.getStoreAllData(shops).paidcount
							},
							drug:{
								drugs:drugs,
								isShow:true,
								allCount:this.getStoreAllData(drugs).count,
								// paidcount:this.getStoreAllData(drugs).paidcount
							},
							haocai:{
								haocais:haocais,
								isShow:true,
								allCount:this.getStoreAllData(haocais).count,
								// paidcount:this.getStoreAllData(drugs).paidcount
							}
						}
						//添加显示状态
						stores[i].isShow = true;
						this.stores = stores;
					}
					this.storeTab = arr;
					this.stores = stores;
					console.log('门店数据',this.stores)
				}
			},
			//分拨后门店整合数据
			getStoreEndData(){
				let stores = [...this.detailData.shopDistributionResponseList];
				let endArr = [];
				for(let i = 0; i<stores.length;i++){
					endArr[i]={};
					endArr[i].isShow = true;
					endArr[i].distributionGoodsList = {};
					endArr[i].distributionGoodsList.drug = {};
					endArr[i].distributionGoodsList.drug.isShow = true;
					endArr[i].distributionGoodsList.drug.drugs = [];
					endArr[i].distributionGoodsList.shop = {};
					endArr[i].distributionGoodsList.shop.isShow = true;
					endArr[i].distributionGoodsList.shop.shops = [];
					endArr[i].distributionGoodsList.haocai = {};
					endArr[i].distributionGoodsList.haocai.isShow = true;
					endArr[i].distributionGoodsList.haocai.haocais = []
					endArr[i].shopInfo= stores[i].shopInfo
				}
				this.endStoreArr = [...endArr]
				// console.log('分拨后整合',startArr,endArr)
			},
			//获取门店合计
			getStoreAllData(arr){
				let count = 0;
				// let paidcount = 0;
				for(let k =0; k<arr.length;k++){
					
					count = (count +arr[k].goodsCount)
					// paidcount = (paidcount + arr[k].validationData.paidCount)
				}
				let obj = {
					count:count,
					// paidcount:paidcount
				}
				// console.log(obj)
				return obj
			},
			//显示或者隐藏对应门店
			handleStoreClick(index){
				let stores = this.stores;
				stores[index].isShow = !stores[index].isShow;
				this.stores = stores
				this.$set(this.stores,index,this.stores[index])
				console.log(stores)
			},
			//显示或者隐藏对应门店的子类
			handleStoreZLClick(index,type){
				let stores = this.stores;
				console.log(index,type,stores[index])
				if(type == 1){
					stores[index].distributionGoodsList.shop.isShow = !stores[index].distributionGoodsList.shop.isShow;
				}else if(type == 2){
					stores[index].distributionGoodsList.drug.isShow = !stores[index].distributionGoodsList.drug.isShow;
				}else if(type == 3){
					stores[index].distributionGoodsList.haocai.isShow = !stores[index].distributionGoodsList.haocai.isShow;
				}
				this.stores = stores
				this.$set(this.stores,index,this.stores[index])
			},
			//tab切换
			handleTabClick(index) {
				console.log(index)
				this.tabIndex = index;
				let PageId = document.querySelector('#page' + index);
				let indexPageTop = document.querySelector('#page-1').offsetTop;
				// console.log(PageId.offsetTop)
				this.$refs['scrollView'].scrollTo({
					'top': PageId.offsetTop - indexPageTop,
					'behavior': 'smooth'
				})
			},
			//获取详情
			getDetailData() {
				let parmars = {
					id: this.id
				}
				caigouDetail(parmars).then((res) => {
					if (res.code == 0) {
						console.log('商品详情', res.data)
						this.detailData = res.data;
						let detail = res.data;
						let shopList = []; //商品列表
						let drugList = []; //药品列表
						let haocaiList = [];  //耗材列表
						this.getStoreStartData(); //获取门店信息
						this.getStoreEndData();  //分拨后门店数据整合
						for (let i = 0; i < detail.procureGoodsList.length; i++) {
							if (detail.procureGoodsList[i].goodsType == 0) {
								shopList[i] = detail.procureGoodsList[i]
							} else if (detail.procureGoodsList[i].goodsType == 1) {
								drugList[i] = detail.procureGoodsList[i]
							}else if (detail.procureGoodsList[i].goodsType == 7) {
								haocaiList[i] = detail.procureGoodsList[i]
							}
							this.shops = shopList.filter(item => item);
							this.drugs = drugList.filter(item => item);
							this.haocais = haocaiList.filter(item => item);
							this.getAllData()
						}
					}
				})
			},
			// 获取总合计
			getAllData() {
				// console.log('商品列表', this.shops)
				// console.log('药品列表', this.drugs)
				let shops = this.shops;
				let drugs = this.drugs;
				let haocais = this.haocais;
				let shopCount = 0;
				let drugCount = 0;
				let haocaiCount = 0;
				if (shops.length > 0) {
					for (let i = 0; i < shops.length; i++) {
						// console.log(shops[i].goodsCount)
						shopCount = (shopCount + shops[i].goodsCount);
					}
					this.shopCount = shopCount;
				}
				if (drugs.length > 0) {
					for (let j = 0; j < drugs.length; j++) {
						drugCount = (drugCount + drugs[j].goodsCount);
					}
					this.drugCount = drugCount;
				}
				if (haocais.length > 0) {
					for (let k = 0; k < haocais.length; k++) {
						haocaiCount = (haocaiCount + haocais[k].goodsCount);
					}
					this.haocaiCount = haocaiCount;
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;

		// 重复头部
		.titleView {
			// width: 98%;
			width: 99%;
			padding: 20px 0;
			// padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}

		.scrollView {
			flex: 1;
			.storeName{
				font-size: 20px;
				color: #1890FF;
				line-height: 64px;
				font-weight: bold;
				display: flex;
				justify-content: space-between;
				align-items: center;
				div:nth-of-type(1){
					margin-left: 20px;
				}
			}
			.codeView{
				background: #EBF4FF;
				color: #3C3C3C;
				overflow: hidden;
				padding: 10px;
				.shopViewName{
					font-size: 18px;
					line-height: 32px;
				}
				.validView{
					overflow: hidden;
					.validViewName{
						font-size: 16px;
						line-height: 30px;
					}
					.active{
						background: #1890FF !important;
						color: #fff !important;
					}
					.codes{
						padding: 0 5px;
						font-size: 14px;
						border: solid 1px #e9e9eb;
						background: #f4f4f5;
						color: #909399;
						line-height: 22px;
						float: left;
						margin-right: 14px;
						margin-bottom: 6px;
					}
					.codes1{
						padding: 0 5px;
						font-size: 14px;
						border: solid 1px #e9e9eb;
						background: #f4f4f5;
						color: #6CDA35;
						line-height: 22px;
						float: left;
						margin-right: 14px;
						margin-bottom: 6px;
					}
				}
			}
		}

		//重复标题
		.comH2 {
			line-height: 64px;
			font-size: 18px;
			display: flex;
			align-items: center;
		}

		.comH2 div {
			margin-left: 20px;
			margin-right: 6px;
			font-weight: bold;
		}

		.comH2 img {
			width: 16px;
			height: 16px;
			background: red;
		}

		.tableWarp {
			border-radius: 6px;
			background: #fff;
			padding: 20px 30px;

			.tableName {
				line-height: 46px;
				background: #F7F6F9;
				font-size: 18px;
				color: #2A2A2A;
				font-weight: bold;
				margin-bottom: 10px;
			}

			.allNum {
				font-size: 14px;
				background: #F5F5F5;
				height: 50px;
				display: flex;
				align-items: center;
				padding-left: 20px;

				div:nth-of-type(1) {
					margin-right: 20px;
				}
			}
		}

		.fix_btn {
			width: 100%;
			height: 72px;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: space-between;
			align-items: center;
			.fix_btn_l{
				margin-left: 20px;
				display: flex;
				align-items: center;
				div:nth-of-type(1){
					width: 60px;
				}
			}
			.fix_btn_r{
				display: flex;
				align-items: center;
				button {
					margin-right: 10px;
				}
				
				button:nth-of-type(5) {
					margin-right: 60px;
				}
				.selectView{
					display: flex;
					align-items: center;
					margin-right: 20px;
					.selectViewName{
						margin-right: 10px;
					}
				}
			}
			
		}

		.tabs {
			margin-top: 10px;
			padding: 10px 0;
			background: #fff;

			button {
				margin-left: 20px;
			}
		}
	}
</style>
